import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from 'src/app/shared/lib/api/graph.service';
import {
	GET_ALL_INVOICES,
	GET_INVOICES_BY_DATE_RANGE_AND_CLIENT,
	UPDATE_PAGO_SAF,
} from '../graphql/invoices.queries';

@Injectable({
	providedIn: 'root',
})
export class InvoicesService {
	constructor(private graphService: GraphService) {}

	/**
	 * @description Obtiene todas las facturas registradas.
	 * @returns Un Observable con la colección de facturas desde GraphQL Sales.
	 */
	getAll(): Observable<any> {
		return this.graphService.queryGraphQLSales<any>({
			query: GET_ALL_INVOICES,
			variables: {},
		});
	}

	/**
	 * @description Actualiza el pago SAF de una factura específica, permitiendo agregar un nuevo pago, eliminar un pago existente o modificar un pago existente.
	 * @param usuario El usuario que realiza la actualización del pago SAF.
	 * @param idInvoice El ID de la factura a actualizar.
	 * @param pagoInvoice La información del pago SAF a agregar, eliminar o actualizar.
	 * @param tipoUpdate El tipo de actualización a realizar: 'ADD' para agregar un nuevo pago, 'DELETE' para eliminar un pago existente o 'UPDATE' para modificar un pago existente.
	 * @returns Un Observable con la respuesta de la mutación GraphQL que actualiza el pago SAF de la factura.
	 */
	updatePago({
		usuario,
		idInvoice,
		pagoInvoice,
		tipoUpdate,
	}: {
		usuario: string;
		idInvoice: string;
		pagoInvoice: {
			id: string;
			tipoAbono: string;
			createdAt: string;
			updatedAt: string;
			monto: number;
			usuario: string;
			fechaPago: string;
			ordenIngresoId?: string;
		};
		tipoUpdate: 'ADD' | 'DELETE' | 'UPDATE';
	}): Observable<any> {
		return this.graphService.mutateGraphQL<any>({
			mutation: UPDATE_PAGO_SAF,
			variables: { usuario, idInvoice, pagoInvoice, tipoUpdate },
		});
	}

	getAllByDateRangeAndClient(
		clientName: String,
		startDate: String,
		endDate: String,
	): Observable<any> {
		return this.graphService.queryGraphQL<any>({
			query: GET_INVOICES_BY_DATE_RANGE_AND_CLIENT,
			variables: { clientName, startDate, endDate },
		});
	}
}
